import Component from '../core/Component'

export default class PlanOpener extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        const plan = Component.getFromElement('plan')
        const data = this.element.dataset.data ? JSON.parse(this.element.dataset.data) : {}
        const route = this.element.getAttribute('href').replace('#', '')

        if (plan) {
            if (route !== 'modal-plan') {
                plan.show(route.replace('#', ''), data)
            } else {
                plan.show()
            }
        }

    }

}